/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// document.addEventListener('variant:changed', function(event) {
//   var variant = event.detail.variant; // Gives you access to the whole variant details
  
//   if (variant != null){
//     var dataProductJSON = document.querySelector('[data-product-json]');
//     var productObj = JSON.parse(dataProductJSON.innerHTML);

//     updatePromoPrice(productObj, variant);
//   }
// });


// Product Condition Code

const conditionsTooltipBtn = document.querySelector(".conditions-tooltip-button");
const conditionsCardSection = document.querySelector(".product-block-list__item--content");
if(conditionsTooltipBtn && conditionsCardSection){
  conditionsTooltipBtn.addEventListener("click", () => { conditionsCardSection.scrollIntoView(); });
}


// Product Promo Code
  
function applyButton(discountCode){
  var discountObject = JSON.parse(localStorage.getItem("discountObject"));
  
  if(discountObject){          
    if(Date.now() - discountObject.expiry > 86400000){
      discountObject.discounts = "";
    }
    
    if(discountObject.discounts.includes(discountCode)){
      discountObject.discounts = discountObject.discounts.replace(discountCode+",","");
      discountObject.discounts = discountCode+"," + discountObject.discounts;
      discountObject.expiry = Date.now();
    } else {
        discountObject.discounts = discountCode+"," + discountObject.discounts;
        discountObject.expiry = Date.now();
    }
  } else {
    discountObject = {
      discounts : discountCode+",",
      expiry : Date.now()
    }
  }
  
  localStorage.setItem("discountObject", JSON.stringify(discountObject));
  fetch('https://dailysale.com/checkout?discount=' + discountObject.discounts)

  document.querySelector("#product-promo-"+discountCode).classList.add("applied");
}

updateTime();
const updateTimeInterval = setInterval(updateTime, 1000);

function updateTime(){
  var expiryTime = document.querySelectorAll(".product-promo__expiry");
  var htmlBody = document.querySelector("body");

  let date2 = new Date();
  date2.setHours(date2.getUTCHours() - 8);
  // date2.setMinutes(date2.getUTCMinutes() - 53);
  
  let hrsLeft = 23 - date2.getHours();
  let minsLeft = 59 - date2.getMinutes();
  let secsLeft = 59 - date2.getSeconds();

  var hrs = hrsLeft < 10 ? "0" : "";
  var mins = minsLeft < 10 ? "0" : "";
  var secs = secsLeft < 10 ? "0" : "";

  if(hrsLeft == 0 && minsLeft == 0 && secsLeft == 0){
    clearInterval(updateTimeInterval);
  }
  
  if(hrsLeft == 23 && minsLeft >= 40){
    htmlBody.classList.add("product-promo__transition");

    clearInterval(updateTimeInterval);
  }
  
  expiryTime.forEach((item) => item.innerHTML = hrs + hrsLeft + "<span>h : </span>" + mins + minsLeft + "<span>m : </span>" + secs + secsLeft + "<span>s</span>");
}


// Load Scripts later

window.onload = (event) => {
  
  // TapCart script loading
  (function () {
    if (!window?.Shopify?.shop?.length) return;
    
    const shopStore = window.Shopify.shop;
    const environment = 'production'; // local, staging, production;

    const srcUrls = {
      local: 'http://localhost:3005/dist/tc-plugins.es.js', // local dev server URL defined in vite.config.js
      staging: 'https://unpkg.com/tapcart-capture-kit@staging/dist/tc-plugins.es.js',
      production: 'https://unpkg.com/tapcart-capture-kit@production/dist/tc-plugins.es.js',
    };
    const srcUrl = srcUrls[environment] || srcUrls.production;

    window['tapcartParams'] = { shopStore, environment };

    // Create a new script element with type module
    const moduleScript = document.createElement('script');
    moduleScript.type = 'module';
    moduleScript.src = srcUrl;
    document.head.appendChild(moduleScript);

    moduleScript.onerror = function () {
      console.error('Capture kit failed to load.');
    };
  })();

};

document.addEventListener("DOMContentLoaded", (event) => {
  // Black Crow script loading
    const bcScript = document.createElement("script");
    bcScript.src = "https://shopify-init.blackcrow.ai/js/core/dailysale-inc.js?shop=dailysale-inc.myshopify.com&tagSrc=ShopifyThemeAppExtension";
    bcScript.async = true;
    document.body.appendChild(bcScript);

    // Alia script loading
    const script = document.createElement("script");
    script.src = "https://backend.alia-cloudflare.com/public/embed.js?shop=dailysale-inc.myshopify.com";
    script.async = true;
    document.body.appendChild(script);
});




 


// const observer = new MutationObserver(mutations => {
//   mutations.forEach((mutation) => { 
//     var shoppayInstallmentsBanner = document.querySelector("shopify-payment-terms").shadowRoot.querySelector("shop-pay-installments-banner");
//     var shopifyInstallmentsCta = shoppayInstallmentsBanner.shadowRoot.querySelector("#shopify-installments-cta");
    
//     shopifyInstallmentsCta.innerText = "ⓘ";
//     shopifyInstallmentsCta.style.textDecoration = "none";
//     shopifyInstallmentsCta.style.fontWeight = "700";
//   })
// });

// observer.observe(document.querySelector(".product-form__buy-buttons"), {
//   childList: true
// });

// var shoppayInstallmentsBanner = document.querySelector("shopify-payment-terms").shadowRoot.querySelector("shop-pay-installments-banner");
// var shopifyInstallmentsCta = shoppayInstallmentsBanner.shadowRoot.querySelector("#shopify-installments-cta");

// shopifyInstallmentsCta.innerText = "ⓘ";
// shopifyInstallmentsCta.style.textDecoration = "none";
// shopifyInstallmentsCta.style.fontWeight = "700";

